import { ListItemText, MenuItem, Select, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getDeliveryTimeLetterLabel } from '../../common/utils/common.utils';

export interface DeliveryTimesSelectProps {
  value?: number | null;
  onChange: (policy: number) => void;
}

export default function DeliveryTimesSelect({ value, onChange }: DeliveryTimesSelectProps): React.JSX.Element {
  const { t } = useTranslation(['settings']);
  const options = useMemo((): React.JSX.Element[] => {
    const result = [];

    // integer is used to display letters like 'A pour A, A pour B, A pour C, etc.'
    for(let i = 1; i <= 7; i++) {
      result.push((
        <MenuItem value={i}>
          <ListItemText primary={t('settings:delivery_time_type', { to: getDeliveryTimeLetterLabel(i) })} />
        </MenuItem>
      ));
    }

    return result;
  }, []);

  return (
    <Select
      fullWidth
      variant="outlined"
      onChange={(e) => onChange(e.target.value as number)}
      value={value}
      displayEmpty
      renderValue={(selected) => (
        !selected
          ? <Typography sx={{color:'placeholder.main'}}>{t('settings:delivery_times_placeholder')}</Typography>
          : t('settings:delivery_time_type', { to: getDeliveryTimeLetterLabel(selected) })
      )}
    >
      {options}
      <MenuItem value={999}>
        <ListItemText primary={t('settings:delivery_time_type', { to: 'X' })} />
      </MenuItem>
    </Select>
  );
}
